import { DateTime } from 'luxon'
import { FunctionComponent } from 'react'

import { tDefaults, tFormats } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const MonthsRangeFormatter: FunctionComponent<
  Formatter<{ from: number; to: number }>
> = ({ value, t }) =>
  value
    ? t(tFormats('dateRange.months'), {
        start: DateTime.fromObject({ month: value.from }),
        end: DateTime.fromObject({ month: value.to }),
      })
    : t(tDefaults('inputs.no-answer'))
